import { NextPageContext } from 'next'

import axios from 'axios'
import nookies from 'nookies'

import { DefaultCookieOptionType, LocalKeyName, RequiredSsrCookieOptions } from 'src/constants'
import { dateDiffSecond } from 'src/libs/date'

const UserId = 'userId'
const UserRole = 'userRole'

export type SaveEmailInput = {
  email: string
  emailExpiresAt: Date | null
  ctx?: Pick<NextPageContext, 'res'>
}

type LoadEmailInput = {
  ctx?: Pick<NextPageContext, 'req'>
}

type RemoveEmailInput = {
  ctx?: Pick<NextPageContext, 'res'>
}

export const ProfileRepository = {
  saveUserIdToLocalStorage: (userId: number) => {
    localStorage.setItem(UserId, `${userId}`)
  },
  saveUserRoleToLocalStorage: (roleName: string) => {
    localStorage.setItem(UserRole, roleName)
  },

  loadUserIdToLocalStorage: (): number | null => {
    const storageValue: string | null = localStorage.getItem(UserId) ?? null
    return storageValue ? Number.parseInt(storageValue) : null
  },
  loadUserRoleToLocalStorage: (): string | null => {
    const storageValue: string | null = localStorage.getItem(UserRole) ?? null
    return storageValue ?? null
  },

  removeUserIdFromLocalStorage: () => {
    localStorage.removeItem(UserId)
  },

  removeUserRoleFromLocalStorage: () => {
    localStorage.removeItem(UserRole)
  },

  /** emailExpiresAt をnullにする事でsession cookieとして保存する */
  saveEmail: async (input: SaveEmailInput) => {
    const { email, emailExpiresAt, ctx } = input

    if (ctx) {
      const maxAge = emailExpiresAt ? dateDiffSecond(new Date(), emailExpiresAt) : undefined
      const options: DefaultCookieOptionType = {
        ...RequiredSsrCookieOptions,
        maxAge,
        httpOnly: true,
      }

      nookies.set(ctx, LocalKeyName.Email, email, options)
    } else {
      await axios.post('/api/save-email', { email, emailExpiresAt })
    }
  },

  loadEmail: async (input?: LoadEmailInput): Promise<string | null> => {
    if (!input) {
      const response = await axios.get('/api/get-email')
      return response.data?.email ?? null
    }

    const cookies = nookies.get(input?.ctx ?? null)
    return cookies[LocalKeyName.Email] ?? null
  },

  removeEmail: async (input?: RemoveEmailInput): Promise<void> => {
    if (!input) {
      await axios.delete('/api/remove-email')
      return
    }
    nookies.destroy(input.ctx ?? null, LocalKeyName.Email)
  },
} as const
